import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import '../../assets/css/index.css';
import pc from '../../assets/images/pc.png';
import logo from '../../assets/images/redesigned.png';

function IndexPage() {
    return (
        <>
            <div className='position-fixed w-100' style={{zIndex: 999,}}>
                {/* دکمه ورود کاربران - گوشه بالا چپ */}
                <Link
                    to={'/login/'}
                    className='btn btn-primary fs-6 fw-bold px-4 py-2'
                    style={{position: 'absolute', top: 16, left: 16}}
                >ورود کاربران</Link>

                <div className='nav d-flex justify-content-around align-items-center mx-auto'
                    style={{height: 150}}>
                    <div className='d-flex'>
                        <img src={logo} style={{maxHeight: 150}} alt="FARVAHAR"
                            className='farvahar-img mx-auto'/>
                    </div>
                    <div className='d-flex flex-row justify-content-around align-items-center w-50'>
                        <Link to={'/'} className='fs-5 fw-bold py-3'>صفحه اصلی</Link>
                        {/* <div className='nav-1'>
                            <p className='fs-5 fw-bold mb-0  py-3'>محصولات</p>
                            <div className="mega-menu-1 mega-menu px-4 py-4 flex-column">
                                <Link
                                    to={'/invoice'}
                                    className="mx-auto"
                                    onClick={(e) => {
                                        const nav = document.querySelector('.nav-2');
                                        nav.style.pointerEvents = 'none';
                                        setTimeout(() => {
                                            nav.style.pointerEvents = 'auto';
                                        }, 500);
                                    }}
                                >نرم افزار واسط سامانه مودیان نسخه آنلاین ( آرسین2 )</Link>
                            </div>
                        </div> */}
                        <Link to={'/about-us'} className='fs-5 fw-bold py-3'>درباره ما</Link>
                    </div>
                </div>
            </div>
            <div className='w-100 header d-flex flex-column' style={{height: '100vh', paddingTop: 200}}>
            <div className='h-100 mx-auto d-flex mt-5'>
                <img src={pc} className=' mx-auto pc-img'/>
            </div>
            <div className='w-100 d-flex'>
                <div className='footer mx-auto p-5 '
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '12px',
                    }}>
                    <div>
                        <p className='fw-bold'>آدرس شرکت: مشهد بلوار معلم نبش معلم 16 برج البان طبقه 5 واحد 1</p>
                        <p className='fw-bold'>تلفن : 05136144100</p>
                    </div>
                    <div className='d-flex'>
                        <a referrerPolicy='origin' target='_blank' className='pointer h-100 ' style={{width:130}}
                        href='https://trustseal.enamad.ir/?id=607621&Code=3h1ZjCnvOcszqirg8oEJoYMbqbqHPsD7'><img
                            referrerPolicy='origin'
                            src='https://trustseal.enamad.ir/logo.aspx?id=607621&Code=3h1ZjCnvOcszqirg8oEJoYMbqbqHPsD7'
                            alt='' code='3h1ZjCnvOcszqirg8oEJoYMbqbqHPsD7'/></a>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default IndexPage;
